import { initRouter } from '@f1/upc-webapp-ui-vue3'
import mainAuth from './auth'

const publicRoutes = [
    { path: '', name: 'Pàgina principal', component: () => import(/* webpackChunkName: "pagina" */ './views/HomeView.vue') },
    { path: '/suggerir/:prefix/:id', name: 'Suggerir', component: () => import(/* webpackChunkName: "pagina" */ './views/SelectUser.vue') },
    { path: '/suggerir-altres/:prefix/:id', name: 'Suggerir Altres', component: () => import(/* webpackChunkName: "pagina" */ './views/SuggestionFormPublic.vue') },
    { path: '/error-ssl/:page', name: 'error-ssl', component: () => import(/* webpackChunkName: "error" */ './components/ErrorSsl.vue'), props: true},
    { path: '/:pathMatch(.*)*', name: 'error', component: Error },
]

const privateRoutes = [
    { path: '', name: 'Pàgina principal', component: () => import(/* webpackChunkName: "pagina" */ './views/HomeView.vue') },
    { path: '/llistat', name: 'Llistar', component: () => import(/* webpackChunkName: "pagina" */ './views/MySuggestions.vue') },
    { path: '/suggerir-upc/:prefix/:id', name: 'Suggerir UPC', component: () => import(/* webpackChunkName: "pagina" */ './views/SuggestionForm.vue') },
]

const router =  initRouter(mainAuth, publicRoutes, privateRoutes)

export default router

